// BCP layout providing sub-navigation for all BCP routes
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp')({
  beforeLoad: ({ location }) => {
    // Redirect /bcp to BIA tab in the continuity workspace
    if (location.pathname === '/bcp') {
      // TanStack Router expects redirect to be thrown as control flow
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/bcp/bia', replace: true });
    }
    return {
      getTitle: () => i18n.t('routeTitles.businessContinuityPlanning'),
    };
  },
  component: BcpLayout,
});

function BcpLayout() {
  return (
    <div className="min-h-[calc(100vh-4rem)]">
      <Outlet />
    </div>
  );
}
